module.exports = __webpack_public_path__ + "assets/vendors/bootstrap-glyphicons-halflings.png";


//////////////////
// WEBPACK FOOTER
// ./legacy_modules/bootstrap/img/glyphicons-halflings.png
// module id = gdxg
// module chunks = 0